import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'

import tokens from '../../design/tokens'

export const TITLE_VARIANT_XL = 'XL'
export const TITLE_VARIANT_L = 'L'
export const TITLE_VARIANT_M = 'M'
export const TITLE_VARIANT_S = 'S'
export const TITLE_VARIANT_MODAL = 'modal'

const CSS_TEXT_ALIGN = [
  'center',
  'end',
  'inherit',
  'initial',
  'justify',
  'left',
  'revert',
  'right',
  'start',
  'unset',
]

const CSS_OVERFLOW_WRAP = [
  'normal',
  'break-word',
  'anywhere',
  'inherit',
  'initial',
  'revert',
  'revert-layer',
  'unset',
]

function getTextElement(variant) {
  switch (variant) {
    case TITLE_VARIANT_XL:
      return 'h1'

    case TITLE_VARIANT_L:
      return 'h2'

    case TITLE_VARIANT_M:
      return 'h3'

    case TITLE_VARIANT_S:
      return 'h4'

    case TITLE_VARIANT_MODAL:
      return 'h2'
  }
}

const handleVariant = ({ variant }) => {
  switch (variant) {
    case TITLE_VARIANT_XL:
      return `
        font-weight: ${tokens.fontWeight.normal};
        font-size: ${tokens.fontSize.xlarge};
        line-height: ${tokens.lineHeight.title};
        letter-spacing: ${tokens.letterSpacing.small};
        

      `

    case TITLE_VARIANT_L:
      return `
        font-weight: ${tokens.fontWeight.normal};
        font-size: ${tokens.fontSize.large};
        line-height: ${tokens.lineHeight.title};
        letter-spacing: ${tokens.letterSpacing.large};


      `

    case TITLE_VARIANT_M:
      return `
        font-weight: ${tokens.fontWeight.normal};
        font-size: ${tokens.fontSize.medium};
        line-height: ${tokens.lineHeight.title};
        letter-spacing: ${tokens.letterSpacing.large};


      `

    case TITLE_VARIANT_S:
      return `
        font-weight: ${tokens.fontWeight.bold};
        font-size: ${tokens.fontSize.standard};
        line-height: ${tokens.lineHeight.title};
        letter-spacing: ${tokens.letterSpacing.standard};
        

      `

    case TITLE_VARIANT_MODAL:
      return `
        font-weight: ${tokens.fontWeight.bold};
        font-size: ${tokens.fontSize.large};
        line-height: ${tokens.lineHeight.title};
        letter-spacing: ${tokens.letterSpacing.standard};
        
        
      `
  }
}

const handleTextAlign = ({ $textAlign }) =>
  CSS_TEXT_ALIGN.includes($textAlign) ? `text-align: ${$textAlign};` : ''

const handleOverflowWrap = ({ $overflowWrap }) =>
  CSS_OVERFLOW_WRAP.includes($overflowWrap)
    ? `overflow-wrap:${$overflowWrap};`
    : ''

const StyledTitle = styled(
  ({ variant, children, ...rest }) =>
    React.createElement(getTextElement(variant), rest, children),
  {
    shouldForwardProp: (propName) => !propName.startsWith('$'),
  },
)`
  font-style: ${tokens.fontStyle.normal};
  color: ${tokens.color.text.default};
  min-width: 0;
  ${handleVariant}
  ${handleTextAlign}
  ${handleOverflowWrap}
`

export const Title = ({
  className,
  variant,
  textAlign,
  overflowWrap,
  children,
  ...rest
}) => {
  return (
    <StyledTitle
      className={className}
      variant={variant}
      $textAlign={textAlign}
      $overflowWrap={overflowWrap}
      {...rest}
    >
      {children}
    </StyledTitle>
  )
}

Title.defaultProps = {
  variant: TITLE_VARIANT_XL,
  overflowWrap: 'normal',
}

Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    TITLE_VARIANT_XL,
    TITLE_VARIANT_L,
    TITLE_VARIANT_M,
    TITLE_VARIANT_S,
    TITLE_VARIANT_MODAL,
  ]),
  textAlign: PropTypes.oneOf(CSS_TEXT_ALIGN),
  overflowWrap: PropTypes.oneOf(CSS_OVERFLOW_WRAP),
}
